import { Download, ExternalLink } from "lucide-react";

export default function StepToAdmission({ data }) {
  const docLink = data?.steps_to_admission;
  if (!docLink) return null;

  const fullUrl = `${process.env.REACT_APP_API_SIEC}${docLink}`;

  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
      {/* Header Bar */}
      <div className="flex items-center justify-between px-5 py-3 border-b">
        <h3 className="text-sm font-semibold text-gray-800">
          Admission Process Guide
        </h3>

        <div className="flex items-center gap-2">
          {/* Download */}
          <a
            href={fullUrl}
            download
            className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md border border-gray-300 bg-white hover:bg-gray-100 transition"
          >
            <Download size={16} />
            Download
          </a>

          {/* Open */}
          <a
            href={fullUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md border border-gray-300 bg-white hover:bg-gray-100 transition"
          >
            <ExternalLink size={16} />
            Open
          </a>
        </div>
      </div>

      {/* PDF Preview */}
      <div className="h-[520px] bg-gray-50">
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(
            fullUrl
          )}&embedded=true`}
          title="Admission Process PDF"
          className="w-full h-full border-0"
        />
      </div>
    </div>
  );
}
